/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/style-prop-object */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react"
import { 
	// getCategories, 
	getVideoCategories 
} from "../../services/Api"
import "../SideBar.scss"
import {ListGroup} from "react-bootstrap";
import QuestionsFeed from "../feed/questions";

class VideoUserSideBar extends Component {
	constructor() {
		super()
		this.state = {
			questions: [],
			categories: [],
		}
	}

	async componentDidMount() {
		const categories = await getVideoCategories()

		console.log(categories)

		this.setState({
			...this.state,
			questions: data,
			categories: categories,
		})
	}
	render() {
		return (
			<React.Fragment>
				<div>
					<div class='sidebar w3-light-grey sideBarWidth '>
						<div className='middleSection' id="sidebar-improve-your-feed">
							<ListGroup>
								<ListGroup.Item className='listFirstItem feedCateGoryName'>
									Improve Your feed{" "}
								</ListGroup.Item>
								<QuestionsFeed/>
							</ListGroup>
						</div>
						<div className='contentHeaders'>
							{" "}
							Video By Content Type
						</div>

						<div
							// onClick={() => this.props.LoadQuestion("questions")}
							className='SidebarIconText'
						>
							<div>
								<img alt="home filled svg"
									className='sideBarIcon'
									src={require("../../icons/home-filled.svg")}
								/>
							</div>
							<div>
								<div class='w3-bar-item  sideBarText '>
									All Videos
								</div>
							</div>
						</div>
						<div
							// onClick={() => this.props.LoadQuestion("questions")}
							className='SidebarIconText'
						>
							<div>
								<img
									className='sideBarIcon'
									src={require("../../icons/home-filled.svg")}
								/>
							</div>
							<div>
								<div class='w3-bar-item  sideBarText '>
									{" "}
									Video with Comments
								</div>
							</div>
						</div>

						<div className='contentHeaders'> By Categories </div>
						{this.state.categories.map((item) => (
							<div
								// onClick={() =>
								// 	this.props.LoadQuestion(item.questions)
								// }
								className='SidebarIconText'
							>
								<div>
									<img
										className='sideBarIcon'
										src={require("../../icons/home-filled.svg")}
									/>
								</div>
								<div>
									<div class='w3-bar-item  sideBarText '>
										{item.categoryName}
									</div>
								</div>
							</div>
						))}
						<div className='contentHeaders'> Video Sort Order </div>

						<div
							// onClick={() => this.props.LoadQuestion("questions")}
							className='SidebarIconText'
						>
							<div>
								<img
									className='sideBarIcon'
									src={require("../../icons/home-filled.svg")}
								/>
							</div>
							<div>
								<div class='w3-bar-item  sideBarText '>
									Newest First
								</div>
							</div>
						</div>
						<div
							// onClick={() => this.props.LoadQuestion("questions")}
							className='SidebarIconText'
						>
							<div>
								<img
									className='sideBarIcon'
									src={require("../../icons/home-filled.svg")}
								/>
							</div>
							<div>
								<div class='w3-bar-item  sideBarText '>
									Oldest First
								</div>
							</div>
						</div>
					</div>
				</div>
			</React.Fragment>
		)
	}
}

export default VideoUserSideBar

const data = [
	{
		category: "Geography",
		questions: [
			{
				question: "What is  geography",
				id: 1,
				displayComments: "none",
				comments: [],
				votes: 1,
			},
			{
				question: "What are  rocks",
				id: 2,
				displayComments: "none",
				comments: [],
				votes: 1,
			},
			{
				question: "What is  meteorite",
				id: 3,
				displayComments: "none",
				comments: [],
				votes: 1,
			},
			{
				question: "How is magma formed",
				id: 4,
				displayComments: "none",
				comments: [],
				votes: 1,
			},
		],
	},
	{
		category: "IOS Development",
		questions: [
			{
				question: "Is Swift Hard",
				id: 1,
				displayComments: "none",
				comments: [],
				votes: 1,
			},
			{
				question: "How to write functions in Swift",
				id: 2,
				displayComments: "none",
				comments: [],
				votes: 1,
			},
			{
				question: "Can you use react native for iOS development",
				id: 3,
				displayComments: "none",
				comments: [],
				votes: 1,
			},
			{
				question: "How to deploy an app on teh IOS store",
				id: 4,
				displayComments: "none",
				comments: [],
				votes: 1,
			},
		],
	},
	{
		category: "Math",
		questions: [
			{
				question: "Can any one with differential equations",
				id: 1,
				displayComments: "none",
				comments: [],
				votes: 1,
			},
			{
				question: "How to do matrices",
				id: 2,
				displayComments: "none",
				comments: [],
				votes: 1,
			},
			{
				question: "What is the best math tutorial in existence",
				id: 3,
				displayComments: "none",
				comments: [],
				votes: 1,
			},
			{
				question: "How to do calculus 3",
				id: 4,
				displayComments: "none",
				comments: [],
				votes: 1,
			},
		],
	},
	{
		category: "Science",
		questions: [
			{
				question: "What is  Science",
				id: 1,
				displayComments: "none",
				comments: [],
				votes: 1,
			},
			{
				question: "How are rocks formed",
				id: 2,
				displayComments: "none",
				comments: [],
				votes: 1,
			},
			{
				question: "WHt is corona virus",
				id: 3,
				displayComments: "none",
				comments: [],
				votes: 1,
			},
			{
				question: "What is the latest scientific development",
				id: 4,
				displayComments: "none",
				comments: [],
				votes: 1,
			},
		],
	},
]
